// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NuP8","content":"styles_content__2HusV"};